import React, { useEffect, useState } from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import { Alert, Loader, Tabs } from '@itds/elements/index.js';

import Config from '@/config';

import CustomActionsList from './CustomActions';
import General from './General';
import LeadFormFields from './LeadFormFields';
import LimitCarriers from './LimitCarriers';
import LimitProductTypes from './LimitProductTypes';
import ThemeOptions from './ThemeOptions';
import EmbedCode from './EmbedCode';

import H1 from '@brokerage/components/H1';
import LimitStates from '@brokerage/components/LimitStates';

import { Api } from '@brokerage/utils/Api';

export const Show = () => {
  const params = useParams();
  const hash = window.location.hash;

  const [website_quoter, setWebsiteQuoter] = useState();
  const [error_message, setErrorMessage] = useState();
  const [success_message, setSuccessMessage] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadWebsiteQuoter();
  }, []);

  const loadWebsiteQuoter = () => {
    setLoading(true);

    Api.loadWebsiteQuoter(params.id).then(response => {
      const { data } = response;

      setWebsiteQuoter(data);
      setLoading(false);
    });
  };

  const handleStatesChange = ({ default_state, states }) => {
    if (!states.length) {
      window.scrollTo(0, 0);
      loadWebsiteQuoter();
      setErrorMessage('Must select at least one state');
      setTimeout(() => {
        setErrorMessage(null);
      }, 2000);
    } else updateWebsiteQuoter({ default_state, states });
  };

  const updateWebsiteQuoter = updated_data => {
    window.scrollTo(0, 0);

    setLoading(true);

    Api.updateWebsiteQuoter(params.id, updated_data)
      .then(({ data }) => {
        setWebsiteQuoter(data);
        setSuccessMessage('Website Quoter updated successfully');
        setTimeout(() => {
          setSuccessMessage(null);
        }, 2000);
        setLoading(false);
      })
      .catch(() => {
        setErrorMessage('Unable to update Website Quoter');
        setTimeout(() => {
          setErrorMessage(null);
        }, 2000);
        setLoading(false);
      });
  };

  const child_props = {
    loadWebsiteQuoter,
    website_quoter,
    setErrorMessage,
    setSuccessMessage,
    setWebsiteQuoter,
    updateWebsiteQuoter
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      {error_message ? <Alert type='error'>{error_message}</Alert> : null}
      {success_message ? <Alert type='success'>{success_message}</Alert> : null}
      <H1>{website_quoter.name}</H1>

      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Tabs
          tabs={[
            {
              label: 'General',
              to: ' ',
              isActive:
                hash.slice(-1) === `${website_quoter.id}`.slice(-1) ||
                hash.slice(-1) === '/'.slice(-1)
            },
            {
              label: 'Limit Carriers',
              to: 'limit_carriers',
              isActive: hash.includes('limit_carriers')
            },
            {
              label: 'Limit Product Types',
              to: 'limit_product_types',
              isActive: hash.includes('limit_product_types')
            },
            {
              label: 'Limit States',
              to: 'limit_states',
              isActive: hash.includes('limit_states')
            },
            {
              label: 'Lead Form Fields',
              to: 'fields',
              isActive: hash.includes('fields')
            },
            {
              label: 'Custom Actions',
              to: 'custom_actions',
              isActive: hash.includes('custom_actions')
            },
            {
              label: 'Theme Options',
              to: 'theme_options',
              isActive: hash.includes('theme_options')
            },
            {
              label: 'Preview',
              onClick: () =>
                window.open(`${Config.WQ_URL}preview.html?token=${website_quoter.guid}`)
            },
            {
              label: 'Embed Code',
              to: 'embed_code',
              isActive: hash.includes('embed_code')
            }
          ]}
          vertical={true}
        />

        <div style={{ flex: 1, paddingLeft: 40 }}>
          <Routes>
            <Route element={<General {...child_props} />} index={true} />
            <Route element={<LimitCarriers {...child_props} />} path='limit_carriers' />
            <Route element={<LimitProductTypes {...child_props} />} path='limit_product_types' />
            <Route
              element={
                <LimitStates
                  defaultState={website_quoter.default_state}
                  handleSave={handleStatesChange}
                  selectedStates={website_quoter.states}
                />
              }
              path='limit_states'
            />
            <Route element={<LeadFormFields {...child_props} />} path='fields' />
            <Route element={<CustomActionsList {...child_props} />} path='custom_actions' />
            <Route element={<ThemeOptions {...child_props} />} path='theme_options' />
            <Route element={null} path='preview' />
            <Route element={<EmbedCode {...child_props} />} path='embed_code' />
          </Routes>
        </div>
      </div>
    </>
  );
};
